((($) => {
	'use strict';

    $('#hero-banner').eqHeight('.page-header');
})(jQuery));
